<template>
  <router-view/>
</template>

<script>
export default {
  created() {
    const prefs = localStorage.getItem('prefs');
    if (prefs) {
      const dark = JSON.parse(prefs).dark;
      const theme = dark ? 'dark' : 'light';
      document.documentElement.setAttribute('data-bs-theme', theme);
      document.documentElement.style.setProperty("color-scheme", theme);
    }
  },

}
</script>
